import { FaLinkedinIn, FaYoutube, FaInstagram } from "react-icons/fa";


const SocialMedia = () => {
    return (


        <div className="d-flex flex-column align-items-center gap-2 mt-4">
            <p className="text-muted fw-semibold mb-1">Connect with us</p>

            <div className="d-flex gap-3">
                <a
                    href="https://www.linkedin.com/company/83509537/admin/page-posts/published/"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon linkedin"
                >
                    <FaLinkedinIn />
                </a>

                <a
                    href="https://www.youtube.com/@oneplacesolar"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon youtube"
                >
                    <FaYoutube />
                </a>

                <a
                    href="https://www.instagram.com/oneplacesolar/"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon instagram"
                >
                    <FaInstagram />
                </a>
            </div>
        </div>
    );
};
export default SocialMedia;